import type { DatasetCartesianEditorWrapperProps } from "./dataset-cartesian-editor.type";

import { DatasetCartesianEditor } from "./dataset-cartesian-editor.component";

export const DatasetCartesianEditorWrapper = ({
  template,
  ...props
}: DatasetCartesianEditorWrapperProps) => {
  if (!template) return null;

  return <DatasetCartesianEditor {...props} template={template} />;
};
